import { Dispatch } from 'redux';
import { request } from '../lib/request';

export const SET_USER_ID = 'SET_USER_ID';
export const SET_CHANNEL_USER_ID = 'SET_CHANNEL_USER_ID';
export const SET_CHANNEL_ID = 'SET_CHANNEL_ID';
export const SET_USER_PHONE = 'SET_USER_PHONE';
export const SET_USER_CODE = 'SET_USER_CODE';
export const SET_USER_LANG = 'SET_USER_LANG';
export const SET_TARIFF_ID = 'SET_TARIFF_ID';

export const ASK_KONSIERGE_REQUEST = 'ASK_KONSIERGE_REQUEST';
export const ASK_KONSIERGE_RESPONSE = 'ASK_KONSIERGE_RESPONSE';
export const ASK_KONSIERGE_ERROR = 'ASK_KONSIERGE_ERROR';

export const setUserIdAction = (userId: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_USER_ID,
    userId,
});

export const setChannelIdAction = (channelId: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHANNEL_ID,
    channelId,
});

export const setChannelUserIdAction = (channelUserId: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHANNEL_USER_ID,
    channelUserId,
});

export const setUserPhoneAction = (phone: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_USER_PHONE,
    phone,
});

export const setUserLangAction = (lang: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_USER_LANG,
    lang,
});

export const setTariffIdAction = (tariffId: number) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_TARIFF_ID,
    tariffId,
});

export const setUserCodeAction = (code: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_USER_CODE,
    code,
});

export const askKonsiergeAction = (body: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: ASK_KONSIERGE_REQUEST,
    });

    return request(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/frontend`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`
        }),
        body: JSON.stringify(body),
    }).then(response => {
        dispatch({
            type: ASK_KONSIERGE_RESPONSE,
            response,
        });
        return response;
    }).catch(error => dispatch({
        type: ASK_KONSIERGE_ERROR,
        error,
    }));
};



// WEBPACK FOOTER //
// ./src/actions/user.ts